import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import { RendererProps } from "../Input";

const CheckboxGroup = ({ options, ...props }: RendererProps) => {
  const values = Array.isArray(props.value) ? props.value : [];
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      props.onChange?.({
        target: {
          name: props.name,
          value: [...values, event.target.name],
        },
      });
    } else {
      props.onChange?.({
        target: {
          name: props.name,
          value: values.filter((val) => val !== event.target.name),
        },
      });
    }
  };

  return (
    <FormGroup {...props} onChange={undefined}>
      {options?.map(({ label, value }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={values.includes(value)}
              name={value}
              onChange={handleChange}
            />
          }
          key={value}
          label={label}
        />
      ))}
    </FormGroup>
  );
};

export default CheckboxGroup;
